import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getCallReportingStats = createAsyncThunk(
  "CallsReportingList/getCallReportingStats",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/calls/stats?fromDate=${data.fromDate}&lastDate=${data.lastDate}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.calls;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

